module.exports = __webpack_public_path__ + "img/medio6.7f6054e3.jpg";